import React, { useMemo } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { Switch } from '@/components/ui/switch';
import { useAssetsAllocation } from '@/components/pages/SettingsPage/MainContent/UserManagement/AssetsAllocation/useAssetsAllocation';
import { updateTableCellData } from '@/components/pages/SettingsPage/MainContent/NotificationPreferences';

export const useAssetsAllocationTable = () => {
  const { data, isLoading, isFetching, updateAssetsAllocation } = useAssetsAllocation();

  const columns: ColumnDef<any>[] = useMemo(() => {
    return [
      {
        accessorKey: 'asset_ui_name',
        header: 'Site Name & Asset Name',
        cell: ({ row }) => {
          const { site_id, asset_ui_name } = row.original;

          return (
            <div>
              <div>{asset_ui_name}</div>
              <div className="text-sm text-gray-500">{site_id}</div>
            </div>
          );
        },
        enableFiltering: false,
        size: 400,
      },
      {
        accessorKey: 'notification',
        header: 'Enable Notifications per Asset',
        cell: ({ getValue, row, column, table }) => {
          const checked = getValue() as boolean;

          const handleToggle = (value: boolean) => {
            updateTableCellData({
              rowIndex: row.index,
              columnId: column.id,
              value,
              table,
            });
          };

          return <Switch checked={checked} onCheckedChange={handleToggle} />;
        },
        enableFiltering: false,
      },
    ];
  }, []);

  return {
    columns,
    data: data || [],
    isLoadingAssetsAllocation: isLoading || isFetching,
    updateAssetsAllocation,
  };
};
